import {
	Box,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography,
} from "@mui/material";
import { BaseAlertPropType } from "../../../types/app.type";
import { BaseAlertModalWrapper } from "./styled";
import { Caution, SuccessTick } from "../../../assets";
import { BaseButton } from "../../button/styled";

export const BaseAlertModal: React.FC<BaseAlertPropType> = ({
	open,
	handleClose,
	title,
	message,
	callToAction,
	handleCallToAction,
	hideTick,
	hideCTA,
	hideMessage,
	customBody,
	errorTick,
}) => {
	return (
		<BaseAlertModalWrapper open={open} onClose={handleClose}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent className="modal-content">
				<Box
					component={"div"}
					sx={{ display: hideTick ? "none" : "flex", justifyContent: "center" }}
				>
					{errorTick ? <Caution /> : <SuccessTick />}
				</Box>
				{customBody && customBody}
				<DialogContentText
					variant="body1"
					fontFamily={"Inter"}
					fontWeight={400}
					fontSize={20}
					lineHeight={"normal"}
					color={"#373737"}
					marginBlock={"calc(var(--basic-margin))"}
					whiteSpace={"normal"}
					textAlign={"center"}
					display={hideMessage ? "none" : "block"}
				>
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions
				sx={{
					display: hideCTA ? "none" : "flex",
					justifyContent: "center",
					padding:
						"var(--basic-padding) var(--basic-padding) calc(var(--basic-padding) * 2)",
				}}
			>
				<BaseButton
					variant="contained"
					onClick={handleCallToAction}
					sx={{
						width: "100%",
					}}
				>
					<Typography
						variant={"button"}
						fontFamily={"inherit"}
						fontWeight={"inherit"}
						fontSize={"inherit"}
						lineHeight={"inherit"}
						color={"inherit"}
						textTransform={"inherit"}
					>
						{callToAction}
					</Typography>
				</BaseButton>
			</DialogActions>
		</BaseAlertModalWrapper>
	);
};
